module.exports = __webpack_public_path__ + "img/1.39c713b3.jpeg";